import React from 'react'
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Text } from '@chakra-ui/react'

type UtilityChargebackOverrideAlertProps = {
  override?: {
    mode: string
    set_at: string
    reason?: string | null
  } | null
}

function UtilityChargebackOverrideAlert({ override }: UtilityChargebackOverrideAlertProps) {
  if (!override || !['allow', 'block'].includes(override.mode)) return null

  const isAllowed = override.mode === 'allow'
  let effectiveDateLabel: string | undefined
  if (isAllowed) {
    const effectiveDate = new Date(override.set_at)
    effectiveDate.setUTCDate(effectiveDate.getUTCDate() + 1)
    effectiveDateLabel = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC'
    }).format(effectiveDate)
  }

  return (
    <Alert status={isAllowed ? 'info' : 'warning'} alignItems='flex-start' mb={4}>
      <AlertIcon />
      <Box>
        <AlertTitle fontSize='sm'>
          Utility chargeback override: {isAllowed ? 'Allow' : 'Block'}.
        </AlertTitle>
        <AlertDescription fontSize='sm'>
          {isAllowed ? (
            <>
              Eligible utility bills with payment dates on or after {effectiveDateLabel} (UTC) can
              be charged to this rental, including in states that normally block automatic
              chargebacks. Earlier bills follow the usual rules. Standard $15 utility late-fee rules
              and other chargeback restrictions still apply.
            </>
          ) : (
            <>
              Automatic utility chargebacks and their $15 late fees are blocked for this rental.
              Existing charges are unchanged.
            </>
          )}{' '}
          Contact Engineering to change this override.
        </AlertDescription>
        {override.reason && (
          <Text fontSize='sm' mt={2} whiteSpace='pre-wrap' overflowWrap='anywhere'>
            Reason: {override.reason}
          </Text>
        )}
      </Box>
    </Alert>
  )
}

export default UtilityChargebackOverrideAlert
